/**
 * Format a timestamp for display in the chat.
 * Shows "Today 2:20pm" for today, or "Friday 2:20pm" for other days.
 */
export function formatTimestamp(date: Date): string {
    const now = new Date();
    const isToday = date.toDateString() === now.toDateString();

    const timeStr = date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }).toLowerCase();

    if (isToday) {
        return `Today ${timeStr}`;
    }

    const dayStr = date.toLocaleDateString([], { weekday: 'long' });
    return `${dayStr} ${timeStr}`;
}
